import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import { Divider, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";

import { useWidth } from "@/shared/hooks/use-width.hook";
import TextSimple from "../../typography/text-simple/TextSimple";

export interface IFormModalProps {
  btnToggle: JSX.Element;
  title: string;
  FormComponent: JSX.Element;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  style?: React.CSSProperties;
  styleDialogContent?: React.CSSProperties;
  keepMounted?: boolean;
  closeModalId?: string;
  hiddenDivider?: boolean;
  titleColor?:
    | "blue"
    | "blue-01"
    | "blue-02"
    | "gray"
    | "red"
    | "green"
    | "black"
    | "white"
    | "gray-02";
  isShowText?: boolean;
  decline?: () => void;
}

export interface IFormModalExtendedProps {
  modalToggle?: () => void;
}

export default function FormModal(props: IFormModalProps) {
  const [open, setOpen] = React.useState(false);
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);

  const handleToggleModal = (state: boolean | null = null) => {
    state != null ? setOpen(state) : setOpen(!open);
  };

  React.useEffect(() => {}, []);

  return (
    <div>
      {React.cloneElement(props.btnToggle, {
        onClick: handleToggleModal
      })}
      <CustomDialog
        fullWidth={true}
        maxWidth={
          props.style ? false : isMobile ? "md" : props.size ? props.size : "sm"
        }
        open={open}
        keepMounted={props.keepMounted ?? false}
        PaperProps={{
          style: props.style
        }}
      >
        <CustomTitle>
          <TextSimple
            align="center"
            color={props.titleColor ? props.titleColor : "blue"}
            size="title"
            font="gotham"
          >
            {props.title}
          </TextSimple>
          <CustomIconButton
            onClick={() => {
              handleToggleModal();
              if (props?.decline) {
                props?.decline();
              }
            }}
            id={props?.closeModalId}
          >
            <CloseIcon />
          </CustomIconButton>
        </CustomTitle>
        <DialogContent
          style={{
            ...props.styleDialogContent,
            padding: props.isShowText ? "2px 15px" : ""
          }}
        >
          {!props.hiddenDivider && <Divider />}
          <CustomForm>
            {React.cloneElement(props.FormComponent, {
              modalToggle: handleToggleModal
            })}
          </CustomForm>
        </DialogContent>
      </CustomDialog>
    </div>
  );
}

const CustomTitle = styled(DialogTitle)`
  display: flex;
  flex-direction: row;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

const CustomDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 20px;
  }

  .MuiBackdrop-root {
    background-color: #3468c3;
    opacity: 0.5 !important;
  }
`;
const CustomForm = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 100%;
  // padding: 0px 10px;
  padding-bottom: 10px;
  .check-box-groups .check-box-field {
    color: var(--color-gray-02);
  }
`;

const CustomIconButton = styled(IconButton)`
  width: 20px;
  height: 20px;
  padding: 5px;
  background-color: red;
  svg {
    width: 15px;
    height: 15px;
    color: white;
  }
  &:hover {
    background-color: black;
  }
`;
